import { gql } from '@apollo/client';

// Query to get iOS download URL from backend
export const GET_IOS_URL = gql`
  query {
    getDownloadUrls {
      ios
      android
    }
  }
`;
